import React from 'react';
import './index.css';
import ServiceRow from './ServiceRow';

export default class ServicesMap extends React.Component{

    render(){

        const services = this.props.data.map(data => {
            return <ServiceRow data={data} />
        })

        return(
            <div className='services-map'>
                {services}
            </div>
        );

    }

}